import { render, staticRenderFns } from "./MaintainEdit.vue?vue&type=template&id=5c529074&scoped=true"
import script from "./MaintainEdit.vue?vue&type=script&lang=js"
export * from "./MaintainEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c529074",
  null
  
)

export default component.exports